import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getEmail = (state) => resolveProp('novaUser.email', state);
const getFirstName = (state) => resolveProp('novaUser.first-name', state);
const getFamilyName = (state) => resolveProp('novaUser.family-name', state);
const getRoles = (state) => resolveProp('novaUser.roles', state);

export default createSelector(getEmail, getFirstName, getFamilyName, getRoles, (email, firstName, lastName, roles) => ({
    email,
    firstName,
    lastName,
    roles,
    fullName: [firstName, lastName].filter(Boolean).join(' '),
}));
